import * as Linking from "expo-linking";
import isEmpty from "lodash/isEmpty";
import { View } from "react-native";
import { IconButton, TouchableRipple, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import useSnackbar from "../../../../../contexts/SnackbarContext";
import useTransactionDetailsAPI from "../../../contexts/TransactionDetailsAPIContext";
import { TransactionDetails } from "../../../types";
import CardText from "../../CardText";

type Props = {
  contact: TransactionDetails["consumer"]["contact"];
};

export default function ConsumerContactInfo({ contact }: Props) {
  const { showMessage } = useSnackbar();
  const tailwind = useTailwind();

  if (isEmpty(contact)) {
    return null;
  }

  const { whatsapp, email, errorMessage } = contact;

  const shareWhatsapp = () => {
    try {
      // TODO: do we want to send anything prefilled as message?
      Linking.openURL(`whatsapp://send?phone=${whatsapp}`);
    } catch {
      showMessage("No pudimos abrir WhatsApp. Revisa que esté instalado.");
    }
  };

  const shareEmail = () => {
    try {
      // TODO: do we want to prefill any fields or set a message?
      Linking.openURL(`mailto:${email}`);
    } catch {
      showMessage("No pudimos abrir la aplicación de correos.");
    }
  };

  return (
    <View>
      <CardText.Subtitle text="Contacto" />
      {errorMessage && (
        <CardText.Body text={errorMessage} error style={tailwind("mt-2")} />
      )}
      <ContactItem
        text={whatsapp}
        copyText="Teléfono copiado"
        icon="whatsapp"
        onPress={shareWhatsapp}
      />
      <ContactItem
        text={email}
        copyText="Correo electrónico copiado"
        icon="email"
        onPress={shareEmail}
      />
    </View>
  );
}

type ContactItemProps = {
  text?: string;
  copyText: string;
  icon: string;
  onPress: () => void;
};

const ContactItem = ({ text, copyText, icon, onPress }: ContactItemProps) => {
  const { colors } = useTheme();
  const tailwind = useTailwind();
  const { copyToClipboard } = useTransactionDetailsAPI();
  const { showMessage } = useSnackbar();

  function copy() {
    if (!text) return;
    copyToClipboard(text);
    showMessage(copyText);
  }

  if (!text) {
    return null;
  }

  return (
    <TouchableRipple onPress={copy} style={tailwind("-mx-4 px-4")}>
      <View style={tailwind("flex-row justify-between items-center")}>
        <CardText.Body text={text} />
        <View style={tailwind("flex-row gap-1 items-center")}>
          <IconButton
            icon="content-copy"
            iconColor={colors.onSecondaryContainer}
            onPress={copy}
            style={tailwind("m-1")}
          />
          <IconButton
            icon={icon}
            mode="contained-tonal"
            iconColor={colors.onSecondaryContainer}
            containerColor={colors.secondaryContainer}
            onPress={onPress}
            style={tailwind("m-1")}
          />
        </View>
      </View>
    </TouchableRipple>
  );
};
